import { Flex, FlexProps, Skeleton, Stack } from "@chakra-ui/react";
import ProfileAvatar from "components/ProfileAvatar";
import { Text12, Text14 } from "components/Text";
import { NewHireJourney } from "models/v2/newHireJourney";
import { isInPast, dateToAbbrevMonthYear } from "helpers/time";

interface NewHireAvatarNameStartProps extends FlexProps {
  newHireJourney: NewHireJourney | undefined;
}

export default function NewHireAvatarNameStart({ newHireJourney, ...rest }: NewHireAvatarNameStartProps) {
  return (
    <Flex gap="4" {...rest}>
      <ProfileAvatar
        size="xs"
        user={newHireJourney?.newHire}
      />
      {!newHireJourney ? <Skeleton width="100px" height="24px" /> : (
        <Stack gap="1">
          <Text14 fontWeight="700">
            {newHireJourney?.newHire?.fullName}
          </Text14>
          <Text12 color="content.tertiary">
            {isInPast(newHireJourney?.startDate) ? `Started ${dateToAbbrevMonthYear(newHireJourney?.startDate)}` : `Starting ${dateToAbbrevMonthYear(newHireJourney?.startDate)}`}
          </Text12>
        </Stack>
      )}
    </Flex>
  );
}
